export default __webpack_public_path__ + "static/Summary_BgImage-3ef8a390675721cad6fbbdce5828fe91.jpg";